import { useEffect, useState } from "react";
import { Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { adminGetBlog, adminGetPost, adminCreatePost, adminUpdatePost, adminDeletePost } from "./adminApi";
import { Text, Area, Select, Toggle, ImageField, ListEditor, Modal, Label } from "./ui";
import { Header } from "./AdminTours";

const CATS = ["Travel Tips", "Visa Information", "Indian Festivals", "Packing Guides", "Shopping Guide", "Food Guide", "Safety Tips", "Travel Inspiration"];
const blank = { title: "", category: "Travel Tips", excerpt: "", content: "", tags: [], featured_image: "", author: "Legacy India Travel", status: "published", featured: false, seo: { meta_title: "", meta_description: "", keywords: "" } };

export default function AdminBlog() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => adminGetBlog().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const openEdit = async (p) => {
    try { const full = await adminGetPost(p.slug); setEditing({ ...blank, ...full, seo: { ...blank.seo, ...(full.seo || {}) } }); }
    catch { setEditing({ ...blank, ...p }); }
  };
  const save = async () => {
    if (!editing.title) { toast.error("Title required"); return; }
    setSaving(true);
    try {
      if (editing.id) await adminUpdatePost(editing.id, editing); else await adminCreatePost(editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); } finally { setSaving(false); }
  };
  const del = async (p) => { if (!window.confirm(`Delete "${p.title}"?`)) return; await adminDeletePost(p.id); toast.success("Deleted"); load(); };
  const set = (k, v) => setEditing((e) => ({ ...e, [k]: v }));
  const setSeo = (k, v) => setEditing((e) => ({ ...e, seo: { ...e.seo, [k]: v } }));

  const filtered = items.filter((p) => p.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <Header title="Blog" count={items.length} onNew={() => setEditing({ ...blank })} q={q} setQ={setQ} newLabel="Add Post" />
      <div className="bg-white border border-[#d4af37]/25">
        {filtered.map((p) => (
          <div key={p.id} className="flex items-center gap-4 px-5 py-3 border-b border-[#d4af37]/15 last:border-0">
            <img src={p.featured_image} alt="" className="w-14 h-14 object-cover shrink-0" />
            <div className="flex-1 min-w-0"><div className="font-medium text-[#3b1a1a] truncate">{p.title}</div><div className="text-xs text-[#5a4b4b]">{p.category}</div></div>
            <span className={`text-[10px] uppercase px-2 py-1 ${p.status === "published" ? "bg-[#14523d]/15 text-[#14523d]" : "bg-[#5a4b4b]/15 text-[#5a4b4b]"}`}>{p.status}</span>
            <button onClick={() => openEdit(p)} data-testid={`edit-post-${p.id}`} className="w-8 h-8 grid place-items-center text-[#14523d] hover:bg-[#14523d] hover:text-white"><Edit className="w-4 h-4" /></button>
            <button onClick={() => del(p)} className="w-8 h-8 grid place-items-center text-[#7c1d1d] hover:bg-[#7c1d1d] hover:text-white"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {filtered.length === 0 && <div className="px-5 py-10 text-center text-[#5a4b4b]">No posts.</div>}
      </div>

      <Modal open={!!editing} onClose={() => setEditing(null)} title={editing?.id ? "Edit Post" : "Add Post"} wide>
        {editing && (
          <div className="space-y-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Text label="Title *" value={editing.title} onChange={(v) => set("title", v)} />
              <Select label="Category" value={editing.category} onChange={(v) => set("category", v)} options={CATS} />
              <Text label="Author" value={editing.author} onChange={(v) => set("author", v)} />
              <div className="flex items-end gap-6"><Toggle label="Featured" value={editing.featured} onChange={(v) => set("featured", v)} /><Select label="Status" value={editing.status} onChange={(v) => set("status", v)} options={["published", "draft"]} /></div>
            </div>
            <ImageField label="Featured Image" value={editing.featured_image} onChange={(v) => set("featured_image", v)} folder="blog" />
            <Area label="Excerpt" value={editing.excerpt} onChange={(v) => set("excerpt", v)} rows={2} />
            <Area label="Content (HTML supported)" value={editing.content} onChange={(v) => set("content", v)} rows={12} placeholder="<h2>Heading</h2><p>Paragraph...</p>" />
            <ListEditor label="Tags" items={editing.tags} onChange={(v) => set("tags", v)} placeholder="Add tag" />
            <div className="border-t border-[#d4af37]/25 pt-4"><Label>SEO</Label>
              <div className="grid gap-3 mt-1"><Text label="Meta Title" value={editing.seo.meta_title} onChange={(v) => setSeo("meta_title", v)} /><Area label="Meta Description" value={editing.seo.meta_description} onChange={(v) => setSeo("meta_description", v)} rows={2} /></div>
            </div>
            <div className="flex gap-3"><button onClick={save} disabled={saving} data-testid="save-post" className="bg-[#7c1d1d] text-white px-8 py-3 text-xs tracking-[0.2em] uppercase disabled:opacity-60">{saving ? "Saving…" : "Save"}</button><button onClick={() => setEditing(null)} className="border border-[#d4af37]/40 px-8 py-3 text-xs tracking-[0.2em] uppercase">Cancel</button></div>
          </div>
        )}
      </Modal>
    </div>
  );
}
